module.exports = __webpack_public_path__ + "static/media/donate.dae4dac5.jpg";